import { RouteType } from '../enums/route-type.enum';
import { ParamMap } from '@angular/router';

export class MonitoringRouteModel {
    type: RouteType;
    value?: string;
    queryParamMap?: ParamMap;
    subId?: string;

    constructor(type: RouteType, value?: string, queryParamMap?: ParamMap) {
        this.type = type;
        this.value = value;
        this.queryParamMap = queryParamMap;
    }
}
